import { z } from "zod";
import { MetaSchema } from "./shared";
import { InvestmentPlanSchema } from "./shared/InvestmentPlanSchema";

export const PlatformDataSchema = z.object({
  firstMinimumDepositAmount: z.string(),
  secondaryMinimumDepositAmount: z.string(),
  transactionFee: z.string(),

  minimumDailyRewardToClaim: z.string(),
  minimumWithdrawAmount: z.string(),
  monthlyProfitCanWithdraw: z.string(),

  withdrawDays: z.array(z.string()),

  greatMatchingPeriod: z.number(),
  greatMatchingReach: z.number(),
  greatMatchingReward: z.number(),

  quickMatchingPeriod: z.number(),
  quickMatchingReach: z.number(),
  quickMatchingReward: z.number(),

  investMentPlans: z.array(InvestmentPlanSchema),

  percentageMaximumAmountOfUseGGold: z.string(),

  nextArbitrageWithdrawTime: z.number(),
  nextTradeWithdrawTime: z.number(),

  loanFee: z.string(),

  notificationMessage: z.string(),

  percentageFeeConvertGGoldToProfit: z.string(),
  maxCalculatedMarketingPlansPerUser: z.number(),

  arbitrageWithdrawFeePercentage: z.string(),
  percentagePositionOpenFee: z.string(),
  tradeDepositGGOldFee: z.string(),
  percentageFeeConvertUsdtToGold: z.string(),
  tradeWithdrawFeePercentage: z.string(),
});

const PlatformResponse = z.object({
  data: PlatformDataSchema,
  meta: MetaSchema.default,
});

export type InvestmentPlanSchemaType = z.infer<typeof InvestmentPlanSchema>;
export type PlatformResponseType = z.infer<typeof PlatformDataSchema>;

export default PlatformResponse;
